import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

export function createReduxStore(reducer, reducerName, rootSaga, preloadedState) {
  const sagaMiddleware = createSagaMiddleware();
  const reducers = combineReducers({
    [reducerName]: reducer
  });
  const composeEnhancers = composeWithDevTools({ name: reducerName });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));
  let store = createStore(reducers, preloadedState, middleware);
  sagaMiddleware.run(rootSaga);
  return store;
}
